import {ListSortType} from '../enums/ListSortType'
import {compareByPosition, IPositioned} from '../../../../../../helpers/compareByPosition'

export interface IOrderableLabel extends IPositioned {
  title?: string | null
}

export function compareLabels(a: IOrderableLabel, b: IOrderableLabel, sortType?: ListSortType | null): number {
  if(sortType === ListSortType.Alphabetical) {
    const byTitle = String(a.title ?? '').localeCompare(String(b.title ?? ''))
    if(byTitle !== 0) {
      return byTitle
    }
  }
  return compareByPosition(a, b)
}
